import * as t from './actionTypes';
import * as api from './api';

export function createNewArticle(data, successCB, errorCB) {
  return (dispatch) => {
    api.createNewArticle(data, function(success, data, error) {
      if (success) {
        dispatch({ type: t.ARTICLES_CREATE_SUCCESS, article: data });
        successCB();
      } else if (error) {
        errorCB(error);
      }
    })
  }
}

export function createNewLink(data, successCB, errorCB) {
  return (dispatch) => {
    api.createNewLink(data, function(success, data, error) {
      if (success) {
        dispatch({ type: t.LINK_CREATE_SUCCESS, link: data });
        successCB();
      } else if (error) {
        errorCB(error);
      }
    })
  }
}

export function createNewShortcut(data, successCB, errorCB) {
  return (dispatch) => {
    api.createNewShortcut(data, function(success, data, error) {
      if (success) {
        dispatch({ type: t.SHORTCUT_CREATE_SUCCESS, shortcut: data });
        successCB();
      } else if (error) {
        errorCB(error);
      }
    })
  }
}

export function editArticle(id, data, successCB, errorCB) {
  return (dispatch) => {
    api.editArticle(id, data, function(success, data, error) {
      if (success) {
        dispatch({ type: t.ARTICLES_EDIT_SUCCESS, id: id, article: data });
        successCB();
      } else if (error) {
        errorCB(error);
      }
    })
  }
}

export function editLink(id, data, successCB, errorCB) {
  return (dispatch) => {
    api.editLink(id, data, function(success, data, error) {
      if (success) {
        dispatch({ type: t.LINK_EDIT_SUCCESS, id: id, link: data });
        successCB();
      } else if (error) {
        errorCB(error);
      }
    })
  }
}

export function editShortcut(id, data, successCB, errorCB) {
  return (dispatch) => {
    api.editShortcut(id, data, function(success, data, error) {
      if (success) {
        dispatch({ type: t.SHORTCUT_EDIT_SUCCESS, id: id, shortcut: data });
        successCB();
      } else if (error) {
        errorCB(error);
      }
    })
  }
}

export function loadArticles() {
  return dispatch => {
    dispatch({ type: t.SET_BUSY});
    api.getArticles(function (success, articles, error) {
      if (success) {
        dispatch({ type: t.ARTICLES_LOAD_SUCCESS, articles: articles });
        dispatch({ type: t.UNSET_BUSY });
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
      }
    });
  }
}

export function getSettings() {
  return dispatch => {
    api.getSettings(function (settings) {
      dispatch({ type: t.SETTINGS_LOAD_SUCCESS, settings: settings });
    });
  }
}

export function deleteArticle(id, successCB, errorCB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.deleteArticle(id, function(success, error) {
      if (success) {
        dispatch({ type: t.ARTICLES_DELETE_SUCCESS, id: id });
        dispatch({ type: t.UNSET_BUSY });
        successCB();
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
        errorCB(error);
      }
    })
  }
}

export function deleteLink(id, successCB, errorCB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.deleteLink(id, function(success, error) {
      if (success) {
        dispatch({ type: t.LINK_DELETE_SUCCESS, id: id });
        dispatch({ type: t.UNSET_BUSY });
        successCB();
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
        errorCB(error);
      }
    })
  }
}

export function deleteShortcut(id, successCB, errorCB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.deleteShortcut(id, function(success, error) {
      if (success) {
        dispatch({ type: t.SHORTCUT_DELETE_SUCCESS, id: id });
        dispatch({ type: t.UNSET_BUSY });
        successCB();
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
        errorCB(error);
      }
    })
  }
}
